(function () {
    'use strict';

    angular
        .module('oddQuestionnaireTemplateModule')
        .directive('oddQuestionnaireTemplate', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {

        var directiveScope = _.clone(boxTmplScope);
        directiveScope.addQuestionnaire = '&';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$rootScope', '$scope', '$controller',
                function ($rootScope, $scope, $controller) {

                    // Box Template
                    $scope.baseTemplatePath = '/app/shared/odd/questionnaireTemplate/oddQuestionnaireTemplate.[Template].tpl.html';
                    $controller('BoxTmplController', { $scope: $scope });
                    
                    $scope.goToQuestionnaireTemplate = function(qTemplate) {
                        $scope.clickOnBox({ questionnaireTemplate: qTemplate });
                    };

                }],
            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();